import React from 'react';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import {
	getCertificateMetadata,
	getProgramTypeMetadata,
} from '@src/constants/programAttributeMapping';
import { Highlight } from '../Highlight/Highlight';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const ProgramKindHighlight: React.FC<Props> = ({ program, loading }) => {
	const isCertificate = program?.programKind.includes('CERTIFICATE');

	return (
		<>
			{program?.programKind && isCertificate && (
				<Highlight
					body={getCertificateMetadata(program?.programKind).body}
					label='Type'
					loading={loading}
					popoverContent={getCertificateMetadata(program?.programKind).popoverCopy}
				/>
			)}
			{program?.shortProgramKind && !isCertificate && (
				<Highlight
					body={getProgramTypeMetadata(program?.shortProgramKind).body}
					label='Type'
					loading={loading}
					popoverContent={getProgramTypeMetadata(program?.shortProgramKind).popoverCopy}
				/>
			)}
		</>
	);
};
